import { render } from "./BrandFurche.vue?vue&type=template&id=38b8d768"
import script from "./BrandFurche.vue?vue&type=script&lang=ts"
export * from "./BrandFurche.vue?vue&type=script&lang=ts"

import "./BrandFurche.vue?vue&type=style&index=0&id=38b8d768&lang=scss"
script.render = render

export default script